import { Card } from '@shadcn/ui';
import { Users } from 'lucide-react';
import { motion } from 'motion/react';
import { MeAvatar } from '../../../../components/me-avatar';

const AnimatedEllipsis = () => {
    return (
        <motion.span className="inline-block">
            {[0, 1, 2].map((i) => (
                <motion.span
                    key={i}
                    animate={{
                        opacity: [0.4, 1, 0.4],
                    }}
                    transition={{
                        duration: 1.5,
                        repeat: Infinity,
                        delay: i * 0.2,
                        ease: 'easeInOut',
                    }}
                    className="inline-block"
                >
                    .
                </motion.span>
            ))}
        </motion.span>
    );
};

export const ContactSyncInProgressCard = () => {
    return (
        <div className="flex w-full items-center justify-center">
            <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, ease: 'easeOut' }}
                className="w-full max-w-[min(70dvw,60rem)]"
            >
                <Card className="p-6 bg-card border">
                    <div className="flex items-center gap-4 mb-4">
                        {/* Clean loading indicator */}
                        <div className="relative">
                            <MeAvatar className="relative" size="lg" />

                            {/* Subtle spinning border - positioned outside the avatar */}
                            <motion.div
                                className="absolute -inset-1 border-2 border-transparent border-t-primary rounded-full"
                                animate={{ rotate: 360 }}
                                transition={{
                                    duration: 1.5,
                                    repeat: Infinity,
                                    ease: 'linear',
                                }}
                            />
                        </div>

                        <div>
                            <h3 className="text-lg font-medium text-foreground">
                                Syncing your contacts
                                <AnimatedEllipsis />
                            </h3>
                            <p className="text-sm text-muted-foreground mt-1">
                                You should start seeing your most important actions any time now...
                            </p>
                        </div>
                    </div>

                    <div className="space-y-3 text-sm text-muted-foreground">
                        <div className="flex items-start space-x-2">
                            <p>We're analyzing your network and prioritizing your most important conversations</p>
                        </div>
                        <div className="flex items-start space-x-2">
                            <p>
                                Recent interactions will appear first, with your complete network processed over the
                                next few days
                            </p>
                        </div>
                        <div className="flex items-start space-x-2">
                            <p>
                                You can leverage our AI agent to identify opportunities for specific industries, needs,
                                or goals across your entire network
                            </p>
                        </div>
                    </div>
                </Card>
            </motion.div>
        </div>
    );
};
